import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { AnimatedFrame } from './animated_frame';
const animatedTableBodyIsAnimatingCss = "an46wlu";
const animatedTableBodyAnimationTargetOutCss = "a1tlphav";
const animatedTableBodyAnimationDirectionRtlCss = "a1sw2bgd";
const animatedTableBodyAnimationDirectionLtrCss = "a1pt3jod";
const animatedTableBodyAnimationTargetInCss = "a9tufii";
const animatedTableBodyCss = "aa0qzv4";
const AnimatedTableBody = forwardRef((props, ref) => {
  const {
    isAnimating,
    animationTarget,
    animationDirection,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'tbody';
  return <Component ref={ref} {...restProps} className={classNames(animatedTableBodyCss, {
    [animatedTableBodyIsAnimatingCss]: isAnimating,
    [animatedTableBodyAnimationTargetOutCss]: animationTarget?.toString() === 'out',
    [animatedTableBodyAnimationDirectionRtlCss]: animationDirection?.toString() === 'rtl',
    [animatedTableBodyAnimationDirectionLtrCss]: animationDirection?.toString() === 'ltr',
    [animatedTableBodyAnimationTargetInCss]: animationTarget?.toString() === 'in'
  }, props.className)} />;
});
export const WeekContainer = ({
  ...props
}) => <AnimatedFrame as={AnimatedTableBody} {...props} />;
WeekContainer.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired
};

require("./week_container.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./week_container.js");